import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory as createHistory } from 'history';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { reducers, rootSaga } from './behavior';

export const history = createHistory(); //limited capacity
export const localStorage = window.localStorage; //higher capacity that history

const sagaMiddleware = createSagaMiddleware();

const getMiddleware = () => {
  if (window.NODE_ENV === 'development') {
    const composeEnhancers = composeWithDevTools({
      trace: true,
      traceLimit: 25,
    });
    return composeEnhancers(
      applyMiddleware(sagaMiddleware, routerMiddleware(history), createLogger())
    );
  }
  // Enable additional logging in non-production environments.
  return applyMiddleware(sagaMiddleware, routerMiddleware(history));
};

const store = state => {
  const newStore = createStore(reducers(history), state, getMiddleware());
  sagaMiddleware.run(rootSaga);
  return newStore;
};

export default store;
